<!-- <div
  class="w-full bg-[#2b4e4c] px-2 py-4 min-h-[66px] cursor-pointer flex justify-center items-center"
  (click)="router.navigate(['/tax-act-registration'])"
  *ngIf="location.path() !== '/tax-act-registration'"
>
  <p class="underline text-white text-base font-semibold tracking-wider">
    Register for the Kaduna State Conference on the Nigerian Tax Act 2025
  </p>
</div> -->
<header
  [ngClass]="{
    'body-font py-6 px-8': true,
  }"
>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-6 lg:col-span-3">
      <a
        class="flex items-center font-medium text-gray-900 title-font md:mb-0 w-full"
        [routerLink]="'/'"
      >
        <img
          [ngSrc]="'assets/svgs/logoLandingPage.svg'"
          class="w-[161px] rounded-full overflow-hidden object-fill"
          priority
          width="191"
          height="47"
        />
      </a>
    </div>

    <div
      class="hidden lg:flex justify-center col-span-6"
      *ngIf="currentPath && currentPath[0] !== '/user/payment_summary'"
    >
      <nav
        class="flex flex-wrap items-center justify-center flex-1 gap-6 text-base"
      >
        @for (item of navLists; track $index) {
          <a
            class="text-sm text-white nav-item"
            [routerLink]="[item.link]"
            routerLinkActive="nav-item-active"
            [routerLinkActiveOptions]="{ exact: true }"
            >{{ item.name }}</a
          >
        }
      </nav>
    </div>

    <div class="hidden lg:flex gap-3 justify-end items-center col-span-3">
      <button
        nz-button
        nzType="primary"
        nzShape="round"
        class="tax-ai-container flex items-center gap-1 border border-[#42BF798C] bg-[#2264498C] px-4 py-1 text-sm font-semibold text-white !h-12 overflow-hidden"
        (click)="askTaxAI()"
      >
        <span class="tax-ai-left text-white font-black tracking-wide">
          ASK
        </span>

        <img
          [ngSrc]="'assets/images/taxng.png'"
          class="w-[65px] h-[22px] tax-ai-right"
          priority
          width="65"
          height="22"
        />
      </button>

      <div
        *ngIf="isLoggedIn(); else loggedOutActions"
        [ngClass]="{ flex: true }"
      >
        <button
          class="flex px-4 py-2 mr-3 items-center bg-white bg-opacity-25 rounded-md h-12"
          (click)="gotoDashboard()"
        >
          <p class="text-sm font-medium text-white">Dashboard</p>
        </button>

        <button
          class="flex px-4 py-2 mr-3 items-center bg-white bg-opacity-25 rounded-md h-12"
          (click)="logoutHandler()"
        >
          <p class="text-sm font-medium text-white">Logout</p>
        </button>
      </div>

      <ng-template #loggedOutActions>
        <div [ngClass]="{ flex: true }">
          <button
            class="flex px-4 py-2 mr-3 items-center bg-white bg-opacity-25 rounded-md h-12"
            (click)="switchToLogin()"
          >
            <p class="text-sm font-medium text-white">Sign in</p>
          </button>

          <button
            class="flex px-4 py-2 mr-3 items-center bg-white bg-opacity-25 rounded-md h-12"
            (click)="openSignUpPopup()"
          >
            <p class="text-sm font-medium text-white">Register</p>
          </button>
        </div>
      </ng-template>
    </div>

    <div class="col-span-6 flex justify-end lg:hidden">
      <a
        class="ml-3 text-white cursor-pointer hover:text-white"
        (click)="toggleSideMenuVisible()"
      >
        <svg-icon
          [svgStyle]="{ 'width.px': 30 }"
          src="assets/svgs/menu-icon.svg"
        ></svg-icon>
      </a>
    </div>
  </div>

  <nz-modal
    [(nzVisible)]="isModalVisible"
    [nzFooter]="null"
    [nzClosable]="true"
    (nzOnCancel)="clickOut()"
    nzClassName="[&_.ant-modal-body]:px-0 md:[&_.ant-modal-body]:px-6"
    [nzWidth]="activeDisplay === 'register' ? '1050px' : '618px'"
  >
    <div *nzModalContent>
      <div [ngClass]="{ hidden: activeDisplay !== 'login' }">
        <app-login-ui></app-login-ui>
      </div>
      <div [ngClass]="{ hidden: activeDisplay !== 'register' }">
        <app-register-ui [accounTypeList]="accounTypeList()"></app-register-ui>
      </div>
      <div [ngClass]="{ hidden: activeDisplay !== 'forgot-password' }">
        <app-forgot-password-ui></app-forgot-password-ui>
      </div>
      <div [ngClass]="{ hidden: activeDisplay !== 'reset-message' }">
        <app-password-reset-email-notice-ui></app-password-reset-email-notice-ui>
      </div>
      <div [ngClass]="{ hidden: activeDisplay !== 'reset-success' }">
        <app-reset-successful-notice-ui></app-reset-successful-notice-ui>
      </div>
      <div [ngClass]="{ hidden: activeDisplay !== 'reset-password' }">
        <app-reset-password-ui></app-reset-password-ui>
      </div>
    </div>
  </nz-modal>
</header>
